import { render, staticRenderFns } from "./ChatList.vue?vue&type=template&id=299037f8&scoped=true&"
import script from "./chat-list.js?vue&type=script&lang=js&"
export * from "./chat-list.js?vue&type=script&lang=js&"
import style0 from "./chat-list.scss?vue&type=style&index=0&id=299037f8&prod&lang=scss&scoped=true&"
import style1 from "./global.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299037f8",
  null
  
)

export default component.exports